// Stable private submission-email alias derivation.
// Shared by /dashboard, /submit and the (server-side) email intake matcher so
// the alias a customer sees is always the alias inbound mail matches against.

export const EMAIL_INTAKE_DOMAIN =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_EMAIL_INTAKE_DOMAIN) ||
  "review.example.com";

export const EMAIL_INTAKE_LOCAL_PREFIX = "submit";

/**
 * Derive a stable, opaque short code from a user id. 8 hex chars (~32 bits) is
 * plenty for private aliases: unguessable in normal traffic and readable when
 * shown in the UI. Uppercased for legibility.
 */
export function shortCodeFromUserId(userId: string | null | undefined): string {
  if (!userId) return "GUEST000";
  const hex = userId.replace(/-/g, "").slice(0, 8);
  return hex.toUpperCase();
}

export function aliasForUserId(userId: string | null | undefined, domain = EMAIL_INTAKE_DOMAIN) {
  const code = shortCodeFromUserId(userId);
  return `${EMAIL_INTAKE_LOCAL_PREFIX}+${code}@${domain}`;
}

/**
 * Extract the short code from an inbound "To:" address of the form
 * `submit+CODE@domain` or `<Name> <submit+CODE@domain>`. Returns null when the
 * address doesn't match the intake pattern.
 */
export function shortCodeFromAlias(rawAddress: string): string | null {
  if (!rawAddress) return null;
  const m = rawAddress.match(/([a-zA-Z0-9._-]+)\+([A-Za-z0-9]+)@([^\s>]+)/);
  if (!m) return null;
  const [, local, code] = m;
  if (local.toLowerCase() !== EMAIL_INTAKE_LOCAL_PREFIX) return null;
  return code.toUpperCase();
}
